import { render, staticRenderFns } from "./CompanyJobRequestDetail.vue?vue&type=template&id=47f2b33d&scoped=true&"
import script from "../../../services/company/job_request/company-job-request-detail.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_request/company-job-request-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_request_detail.css?vue&type=style&index=0&id=47f2b33d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2b33d",
  null
  
)

export default component.exports